export enum ErrorCode {
    ConnectorLockFailure = 'ConnectorLockFailure',
    GroundFailure = 'GroundFailure',
    HighTemperature = 'HighTemperature',
    InternalError = 'InternalError',
    OverCurrentFailure = 'OverCurrentFailure',
    PowerMeterFailure = 'PowerMeterFailure',
    UnderVoltage = 'UnderVoltage',
    EvSignalingError = 'EvSignalingError',
}

export enum ErrorCodeInstructions {
    FirmlyInsertCableInCharger = 'FirmlyInsertCableInCharger',
    CheckRcbo = 'CheckRcbo',
    CheckCableCondition = 'CheckCableCondition',
    ConnectedEvChargingOverLimit = 'ConnectedEvChargingOverLimit',
    CheckSupplyOnAllPhases = 'CheckSupplyOnAllPhases',
    HighTemperatureInfo = 'HighTemperatureInfo',
    RestartCharger = 'RestartCharger',
    RestartChargingSession = 'RestartChargingSession',
    ContactSupport = 'ContactSupport',
    IfProblemRemainsContactSupport = 'IfProblemRemainsContactSupport',
}
